import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const blogApi = createApi({
  reducerPath: "blogApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://pitchplaylists.com",
  }),
  endpoints: (builder) => ({
    getBlogData: builder.query<PostType[], Partial<BlogQueryParams>>({
      query: (queryArg) => ({
        url: `/blog/wp-json/wp/v2/posts`,
        params: { per_page: 3, _embed: true, ...queryArg },
      }),
    }),
    getBlogData3: builder.query<PostType[], Partial<BlogQueryParams>>({
      query: (queryArg) => ({
        url: `/blog/wp-json/wp/v2/posts`,
        params: { per_page: 3, _embed: true, show_home_page: true, ...queryArg },
      }),
    }),
    getFaqCategories: builder.query<PostType[], Partial<BlogQueryParams>>({
      query: (queryArg) => ({
        url: `/blog/wp-json/wp/v2/faq_category`,
      }),
    }),
    getFaqs: builder.query<PostType[], Partial<BlogQueryParams>>({
      query: (queryArg) => ({
        url: `/blog/wp-json/wp/v2/faq`,
      }),
    }),
  }),
});

export type BlogQueryParams = {
  per_page?: number;
  search?: string;
  categories?: string;
  tags?: string;
};

export type PostType = {
  featuredmedia: any;
  id: number;
  title: { rendered: string };
  content: { rendered: string };
  excerpt: { rendered: string };
  date: string;
  link: string;
  _embedded?: {
    "wp:featuredmedia"?: { source_url: string }[];
  };
};

export const { useGetBlogDataQuery, useGetBlogData3Query, useGetFaqCategoriesQuery, useGetFaqsQuery } = blogApi;
